import { render, staticRenderFns } from "./ClientDataConsentPage.vue?vue&type=template&id=803e3954"
import script from "./ClientDataConsentPage.vue?vue&type=script&lang=js"
export * from "./ClientDataConsentPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports